export const limpiarSessionStorage = () => {
  sessionStorage.removeItem("access_token");
  sessionStorage.removeItem("token_nueva_cuenta");
  sessionStorage.clear();
};

export const agregarSessionAccessToken = (token) => {
  sessionStorage.setItem("access_token", token);
};


